import { Capacitor } from '@capacitor/core'

let hapticsPlugin = null

async function getHaptics() {
  if (hapticsPlugin) return hapticsPlugin
  if (!Capacitor.isNativePlatform()) return null
  try {
    const { Haptics } = await import('@capacitor/haptics')
    hapticsPlugin = Haptics
    return Haptics
  } catch {
    return null
  }
}

const sounds = {}

function playSound(name) {
  if (!sounds[name]) {
    sounds[name] = new Audio(`/sounds/${name}.wav`)
    sounds[name].volume = 0.3
  }
  sounds[name].currentTime = 0
  sounds[name].play().catch(() => {})
}

/** Light haptic tap for subtask checkbox toggle */
export async function playSubtaskCheck() {
  const h = await getHaptics()
  if (h) h.impact({ style: 'light' })
}

/** Full celebration: haptic + sound for completing all subtasks */
export async function playTaskComplete() {
  const h = await getHaptics()
  if (h) h.notification({ type: 'success' })
  playSound('success')
}

/** Medium haptic + pop sound for medication logging */
export async function playMedLogged() {
  const h = await getHaptics()
  if (h) h.impact({ style: 'medium' })
  playSound('pop')
}
